import React, { useContext } from 'react';
import './Advance.css';
import { MoneyFormatterContext } from '../../services/context/MoneyFormatterContext.js';
import PropTypeShapes from '../../services/Constants/PropTypeShapes.jsx';
import { defaultAnalyticsVariables, events, pagePrefix } from '../../services/Constants/Analytics.js';
import { AnalyticsPageContext } from '../../services/context/AnalyticsPageContext.js';
import { Money } from '../../services/Constants/ObjectDefinitions.js';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';

/**
 *
 * @param {object} props - the props of the component
 * @param {Money} props.amountAvailable - the total money to display
 * @returns {JSX.Element} Advance Component
 */
export default function Advance({ amountAvailable }) {
  const MoneyFormatter = useContext(MoneyFormatterContext);
  const analyticsPage = useContext(AnalyticsPageContext);
  const pageName = `${pagePrefix}: how it works`;
  const navigateTo = useNavigate();

  const onClick = () => {
    window.utag?.link({
      ...defaultAnalyticsVariables,
      page_name: analyticsPage,
      event_name: [events.interaction],
      link_id: pageName,
    });
    navigateTo(ROUTES.VIEW_ALL_ADVANCES);
  };

  return (
    <section className='advance container-v advance-container'>
      <header className='v-container'>
        <p className='buy-now-pay-later'>Buy now, pay later</p>
        <div className='amount container-v'>
          <h3>{MoneyFormatter.format(amountAvailable)}</h3>
          <p className='medium fund-text'>funds available</p>
        </div>
      </header>
      <button
        className='view-all-advances'
        onClick={ onClick }
      >
        View offers
      </button>
    </section>
  );
}

Advance.propTypes = { amountAvailable: PropTypeShapes.money };
